import { useState } from "react";
import { AppShell } from "../components/AppShell";
import { roleLabel, type MobileRole } from "../lib/access";
import { tabsForRole, type AppTabId } from "../lib/navigation";
import { AgendaTab } from "./tabs/AgendaTab";
import { HomeTab } from "./tabs/HomeTab";
import { PlaceholderTab } from "./tabs/PlaceholderTab";
import { ProfileTab } from "./tabs/ProfileTab";

interface MobileAppScreenProps {
  readonly role: MobileRole;
  readonly ctName: string;
  readonly email: string | null;
  readonly tenantId: string;
  readonly token: string;
}

export function MobileAppScreen({ role, ctName, email, tenantId, token }: MobileAppScreenProps) {
  const [tab, setTab] = useState<AppTabId>("home");
  const tabs = tabsForRole(role);

  return (
    <AppShell
      ctName={ctName}
      roleLabel={roleLabel(role)}
      userName={email ?? "Apogeu"}
      tabs={tabs}
      activeTab={tab}
      onTabChange={setTab}
    >
      {tab === "home" && <HomeTab role={role} ctName={ctName} email={email} onNavigate={setTab} />}
      {tab === "agenda" && <AgendaTab role={role} token={token} tenantId={tenantId} ctName={ctName} />}
      {tab === "profile" && <ProfileTab role={role} ctName={ctName} />}
      {tab === "activity" && <PlaceholderTab role={role} tab={tab} />}
    </AppShell>
  );
}
